module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/save-333db055c8f38e69bb6dc6b60c39c0ab.svg";